import { Entity } from '@core/data/dto/entity';
import { DeliveryOrderLocation } from '../delivery-order-location';
import { Address } from '@core/models/common/address';
import { DtoImport, DtoExport } from '@core/utils/dto';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { DeliveryOrderPickupSchema } from './delivery-order-pickup.schema';
import { Dto } from '@core/data/dto/dto';


export class DeliveryOrderPickup implements Entity {
    public name: string;
    public phoneNumber: string;
    public address: string;
    public notes: string;
    public location: DeliveryOrderLocation;
    public detailedAddress: Address;

    @DtoImport(DeliveryOrderPickupSchema)
    static import(dto: Dto): any {}

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeliveryOrderPickupSchema,
        },
    ])
    export(type?: DtoType): any {}
}
